// import { Button, Typography } from '@mui/material'
// import CardTAG from '../../CardTAG'
// import PasswordInput from '../../PasswordInput'
// import FormLayout from '../FormLayout'
// import { IResetPasswordForm } from './types'

// const SetPasswordForm: React.FC<IResetPasswordForm> = ({
//   register,
//   passwordError = '',
//   passwordRepeatError = '',
// }) => {
//   return (
//     <CardTAG title='Create a new password'>
//       <Typography variant='bodyRegular' align='left' sx={{ marginBottom: '2.8rem' }}>
//         Set your new password.
//       </Typography>
//       <FormLayout>
//         <PasswordInput
//           register={register}
//           fieldName='password'
//           label='New Password'
//           error={passwordError}
//         />
//         <PasswordInput
//           register={register}
//           fieldName='password_repeat'
//           label='Confirm New Password'
//           error={passwordRepeatError}
//         />
//         <Button variant='submitFormButton' type='submit'>
//           <Typography variant='bodyBold'>Save Password</Typography>
//         </Button>
//       </FormLayout>
//     </CardTAG>
//   )
// }

// export default SetPasswordForm


import { Button, Typography } from '@mui/material';
import CardTAG from '../../CardTAG';
import PasswordInput from '../../PasswordInput';
import FormLayout from '../FormLayout';
import { IResetPasswordForm } from './types';

const SetPasswordForm: React.FC<IResetPasswordForm> = ({
  register,
  passwordError = '',
  passwordRepeatError = '',
}) => {
  return (
    <CardTAG title='Create a new password'>
      <Typography variant='bodyRegular' align='left' sx={{ marginBottom: '2.8rem' }}>
        Set your new password.
      </Typography>
      <FormLayout>
        <PasswordInput
          register={register}
          fieldName='password'
          label='New Password'
          error={passwordError}
        />
        <PasswordInput
          register={register}
          fieldName='password_repeat'
          label='Confirm New Password'
          error={passwordRepeatError}
        />
        <Button
          variant='submitFormButton'
          type='submit'
          disabled={!!passwordError || !!passwordRepeatError} // disable if errors
        >
          <Typography variant='bodyBold'>Save Password</Typography>
        </Button>
      </FormLayout>
    </CardTAG>
  );
};

export default SetPasswordForm;
